if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			const productPage = this.closest('[data-js-product-component]');
			const productId = productPage ? String(productPage.dataset.id) : '';
			const variantsElm = productPage ? productPage.querySelector('product-variants') : null;
			const productForm = this.closest('form');

			const yuteProductId = '15689904095497';
			const sisalProductId = '15163057701129';
			const trapilloProductId = '15524821074185';
			const isRopeProduct = [yuteProductId, sisalProductId, trapilloProductId].includes(productId);

			const oneMeterVariants = {
				'15689904095497': {
					'12 mm': '57373980459273',
					'14 mm': '57373964534025'
				},
				'15163057701129': {
					'1 cabo': '55513893830921',
					'2 cabos': '57374036427017',
					'3 cabos': '57374036459785'
				},
				'15524821074185': {
					'Rosa': '56914137317641',
					'Amarillo': '56914137350409',
					'Azul': '56914137383177',
					'Rojo': '56914137809161'
				}
			};

			const priceTiers = {
				'15689904095497': {
					'12 mm': { base: 1.89, from5: 1.79, from10: 1.79 },
					'14 mm': { base: 2.19, from5: 2.09, from10: 2.09 }
				},
				'15163057701129': {
					'1 cabo': { base: 0.20, from5: 0.18, from10: 0.16 },
					'2 cabos': { base: 0.30, from5: 0.27, from10: 0.25 },
					'3 cabos': { base: 0.39, from5: 0.35, from10: 0.32 }
				},
				'15524821074185': {
					'Rosa': { base: 0.25, from5: 0.22, from10: 0.20 },
					'Amarillo': { base: 0.25, from5: 0.22, from10: 0.20 },
					'Azul': { base: 0.25, from5: 0.22, from10: 0.20 },
					'Rojo': { base: 0.25, from5: 0.22, from10: 0.20 }
				}
			};

			const formatMoney = value => new Intl.NumberFormat('es-ES', {
				style: 'currency',
				currency: 'EUR',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(value);

			const findOptionRow = optionName => {
				if ( ! variantsElm ) return null;
				return Array.from(variantsElm.querySelectorAll('[data-js-product-variant]')).find(row => {
					const name = row.querySelector('.product-variant__name');
					return name && name.textContent.trim() === optionName;
				}) || null;
			};

			const getOptionValue = optionName => {
				const row = findOptionRow(optionName);
				if ( ! row ) return '';

				const select = row.querySelector('select[data-js-product-variant-container]');
				if ( select ) return select.value;

				const checked = row.querySelector('input:checked');
				return checked ? checked.value : '';
			};

			const forceOneMeterOption = () => {
				if ( ! variantsElm ) return;

				const hiddenOptionName = productId === sisalProductId ? 'Longitud' :
					productId === trapilloProductId ? 'Metros' : null;

				if ( ! hiddenOptionName ) return;

				const row = findOptionRow(hiddenOptionName);
				if ( ! row ) return;

				row.style.display = 'none';
				row.setAttribute('aria-hidden', 'true');

				const select = row.querySelector('select[data-js-product-variant-container]');
				if ( select ) {
					const option = Array.from(select.options).find(opt => opt.value === '1m');
					if ( option ) {
						select.value = '1m';
						Array.from(select.options).forEach(opt => {
							if ( opt === option ) {
								opt.setAttribute('selected', 'selected');
								opt.setAttribute('data-selected', '');
							} else {
								opt.removeAttribute('selected');
								opt.removeAttribute('data-selected');
							}
						});
					}
					return;
				}

				const inputs = Array.from(row.querySelectorAll('input[type="radio"]'));
				const oneMeter = inputs.find(input => input.value === '1m');
				if ( oneMeter ) {
					inputs.forEach(input => {
						input.checked = input === oneMeter;
						if ( input === oneMeter ) {
							input.setAttribute('checked', 'checked');
							input.setAttribute('data-selected', '');
						} else {
							input.removeAttribute('checked');
							input.removeAttribute('data-selected');
						}
					});
				}
			};

			const getPrimaryChoice = () => {
				if ( productId === yuteProductId ) return getOptionValue('Grosor');
				if ( productId === sisalProductId ) return getOptionValue('Cabos');
				if ( productId === trapilloProductId ) return getOptionValue('Color');
				return '';
			};

			const syncVariantId = () => {
				if ( ! isRopeProduct || ! productPage ) return '';

				forceOneMeterOption();
				const choice = getPrimaryChoice();
				const variantId = oneMeterVariants[productId]?.[choice] || '';
				if ( ! variantId ) return '';

				productPage.querySelectorAll('input[name="id"]').forEach(input => {
					input.value = variantId;
				});

				return variantId;
			};

			const setVisiblePrice = total => {
				if ( ! productPage ) return;

				['price-compact', 'price-extended'].forEach(blockName => {
					const container = productPage.querySelector('[data-update-block="' + blockName + '"]');
					if ( ! container ) return;

					container.querySelectorAll('.product-price--original').forEach(priceElm => {
						const textNodes = Array.from(priceElm.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
						const priceTextNode = textNodes.find(node => node.textContent.trim().length > 0);
						if ( priceTextNode ) {
							priceTextNode.textContent = ' ' + formatMoney(total);
						} else {
							priceElm.appendChild(document.createTextNode(formatMoney(total)));
						}
					});
				});
			};

			const ensurePricingNotice = () => {
				if ( ! productPage ) return null;

				let notice = productPage.querySelector('[data-lorolivo-dynamic-price]');
				if ( notice ) return notice;

				const extendedPrice = productPage.querySelector('[data-update-block="price-extended"]');
				if ( ! extendedPrice ) return null;

				notice = document.createElement('div');
				notice.setAttribute('data-lorolivo-dynamic-price', '');
				notice.setAttribute('role', 'status');
				notice.style.display = 'none';
				notice.style.margin = '8px 0 14px';
				notice.style.padding = '10px 12px';
				notice.style.borderRadius = '10px';
				notice.style.fontSize = '14px';
				notice.style.lineHeight = '1.4';
				notice.style.fontWeight = '650';

				extendedPrice.insertAdjacentElement('afterend', notice);
				return notice;
			};

			const showNotice = (discounted, html) => {
				const notice = ensurePricingNotice();
				if ( ! notice ) return;

				notice.innerHTML = html;
				notice.style.display = 'block';

				if ( discounted ) {
					notice.style.background = '#f2f7f1';
					notice.style.border = '1px solid rgba(64, 105, 69, .22)';
					notice.style.color = '#315c37';
				} else {
					notice.style.background = '#f7f7f7';
					notice.style.border = '1px solid rgba(0, 0, 0, .10)';
					notice.style.color = '#444';
				}
			};

			const hideNotice = () => {
				const notice = ensurePricingNotice();
				if ( notice ) {
					notice.style.display = 'none';
					notice.textContent = '';
				}
			};

			const ensureMeterLabel = () => {
				if ( ! isRopeProduct || ! this.parentElement ) return;
				if ( this.parentElement.querySelector('[data-lorolivo-meter-label]') ) return;

				const wrapper = document.createElement('div');
				wrapper.setAttribute('data-lorolivo-meter-label', '');
				wrapper.style.margin = '4px 0 8px';
				wrapper.innerHTML =
					'<div style="font-size:18px;font-weight:700;line-height:1.2;">Metros</div>' +
					'<div style="font-size:13px;opacity:.72;margin-top:3px;">Usa + / − o escribe directamente la cantidad.</div>';

				this.insertAdjacentElement('beforebegin', wrapper);
			};

			const updatePricing = () => {
				if ( ! isRopeProduct ) return;

				syncVariantId();

				let meters = parseInt(qty.value, 10);
				if ( ! Number.isFinite(meters) || meters < 1 ) meters = 1;

				const choice = getPrimaryChoice();
				const tiers = priceTiers[productId]?.[choice];
				if ( ! tiers ) return;

				const unitPrice = meters >= 10 ? tiers.from10 : meters >= 5 ? tiers.from5 : tiers.base;
				const total = unitPrice * meters;
				const regularTotal = tiers.base * meters;
				const saving = Math.max(0, regularTotal - total);
				const discounted = meters >= 5 && saving > 0.0001;

				setVisiblePrice(total);

				if ( discounted ) {
					showNotice(
						true,
						'<strong>Descuento por cantidad aplicado</strong><br>' +
						meters + ' m · <strong>' + formatMoney(unitPrice) + '/m</strong> · ' +
						'Ahorras <strong>' + formatMoney(saving) + '</strong> · ' +
						'Antes <s>' + formatMoney(regularTotal) + '</s>'
					);
				} else if ( meters > 1 ) {
					showNotice(
						false,
						meters + ' m × ' + formatMoney(tiers.base) + '/m = <strong>' + formatMoney(total) + '</strong>'
					);
				} else {
					hideNotice();
				}
			};

			if ( isRopeProduct ) {
				qty.setAttribute('step', '1');
				qty.setAttribute('inputmode', 'numeric');
				qty.setAttribute('pattern', '[0-9]*');
				ensureMeterLabel();
				forceOneMeterOption();
			}

			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qty.addEventListener('input', () => {
				if ( isRopeProduct ) updatePricing();
			});

			qty.addEventListener('change', () => {
				let currentQty = parseInt(qty.value, 10);
				if ( ! Number.isFinite(currentQty) || currentQty < qtyMin ) {
					currentQty = qtyMin;
					qty.value = currentQty;
				}
				if ( currentQty > qtyMax ) {
					currentQty = qtyMax;
					qty.value = currentQty;
				}

				qtyMinus.classList.toggle('disabled', currentQty - 1 < qtyMin);
				qtyPlus.classList.toggle('disabled', currentQty + 1 > qtyMax);

				if ( isRopeProduct ) updatePricing();
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					}
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}
					if ( isRopeProduct ) updatePricing();
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					}
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
					if ( isRopeProduct ) updatePricing();
				}
			});

			if ( variantsElm && isRopeProduct ) {

				variantsElm.addEventListener('change', () => {
					forceOneMeterOption();
					syncVariantId();
					setTimeout(updatePricing, 0);
				}, true);

				variantsElm.addEventListener('VARIANT_CHANGE', () => {
					forceOneMeterOption();
					syncVariantId();
					setTimeout(updatePricing, 0);
				});
			}

			if ( productForm && isRopeProduct ) {
				productForm.addEventListener('submit', () => {
					forceOneMeterOption();
					syncVariantId();
				}, true);
			}

			if ( isRopeProduct ) {
				setTimeout(updatePricing, 0);
			}

		}

	}

	if ( typeof customElements.get('product-quantity') === 'undefined' ) {
		customElements.define('product-quantity', ProductQuantity);
	}

}